import React, { useState, useContext, useEffect } from "react";
import Button from "@material-ui/core/Button";
import { Grid, Typography } from "@material-ui/core";
import useStyles from "../../../../../css/styles_PE";
import { AppointmentType, ApptContext, InitialSlotsObj } from "../../../../../store";   //FB 8549
import { GetAdminSettingValue, GetAppointmentTypeFromAdmin, ValidateAppointmentType } from "../../../../../api";
import AppointmentFilterPage from "./AppointmentFilter";
import { GetAppointmentTypes } from "../../../../../api/PE_API";    //FB 8549

// update log
// FB 8024 SK    01/10/2024    Including Recent Patient Engagement Enhancements to Patient Portal
// FB 8549 DK    10/21/2024    TeleHealth re-work

export default function AppointmentTypePage(props: any) {
    const classes = useStyles();
    const { state, dispatch } = useContext(ApptContext);
    const [customApptType, setCustomAppointmentType] = useState(state.CustomAppointmentType);
    //FB 8549 Start
    const [appointmentTypes, setAppointmentTypes] = useState<AppointmentType[]>([]);

    const handleClick = (type: AppointmentType) => {
        setCustomAppointmentType(type.NAME);
        sessionStorage.setItem("AppointmentType_N", type.Id.toString());
        sessionStorage.setItem("AppointmentType", type.NAME);
        sessionStorage.setItem("Duration", type.DURATION.toString());

        state.AppointmentType = state.AppointmentType;
        state.CustomAppointmentType = type.NAME;
        state.AppointmentFilter = "";
        state.Provider = {
            ID: 0,
            Name: "",
            Facility_n: 0,
            Bio: "",
            JobTitle: ""
        };
        state.Facility = {
            ID: 0,
            Name: "",
            Address: "",
            Phone: "",
            Region: 0,
            GOOGLE_MAPS_LINK: "" // FB 7413
        };
        state.FacilityRegion = {
            ID: 0,
            Name: "",
            State: ""
        }
        state.AppointmentDate = new Date();
        state.Duration = 0;
        state.SlotDetails = InitialSlotsObj;
        state.Appointment_N = 0;
    }
    //FB 8549 End

    const handleGoback = () => {
        if (props.origin === "PatientType") {
            props.setApptType("");
            //   InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Appointment Type");
        }
        else {
            props.setApptType("");
            //   InsertPELogs(globalsettings.clientIp, "Clicked on Go Back - Appointment Type");
        }
    };

    function getcomponent() {
        if (customApptType != "") {
            return <AppointmentFilterPage setCustomAppointmentType={setCustomAppointmentType} />
        }

    }

    //FB 8549
    async function fetchAppointmentTypes() {
        var filter = state.AppointmentType != undefined ? state.AppointmentType : "";
        var types = await GetAppointmentTypes(filter, "existing");
        if (types != null) {
            setAppointmentTypes(types);
        }
    }

    useEffect(() => {
        fetchAppointmentTypes();
    }, []);

    const scrollTo = (ref: any) => {
        if (ref /* + other conditions */) {
            ref.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };


    return (
        <div ref={scrollTo}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography id="chooseMessage" variant="h6">
                        Choose Appointment Type
                    </Typography>
                </Grid>
            </Grid>
            <Grid container spacing={2} >
            {/* FB 8549 Start*/}
                {appointmentTypes.map((type) => (
                    <Grid item key={type.Id}>
                        <Button
                            variant="outlined"
                            onClick={() => handleClick(type)}
                            className={
                                customApptType === type.NAME
                                    ? classes.buttonActive
                                    : classes.buttonInactive
                            }
                        >
                            {type.NAME}
                        </Button>
                        {/* FB 8549 End*/}
                    </Grid>
                ))}
            </Grid>
            <Grid
                container
                spacing={2}
                className={classes.flexend_Grid}
                style={{
                    display: customApptType === "" ? "inline-flex" : "none",
                }}
            >
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    lg={3}
                    className={classes.flexend_Grid}
                    style={{ marginTop: 10 }}
                >
                    <Button
                        onClick={handleGoback}
                        id="gobackByDate"
                        variant="contained"
                        className={classes.navigationButton}
                    >
                        Go Back
                    </Button>
                </Grid>
            </Grid>
            <React.Fragment>{getcomponent()}</React.Fragment>
        </div>
    );
}
